import React from 'react';
export default function Skills() {
  
  return (
    <div>
       <div id="skills" className="skills-container">
        <p className="skills">Skills</p>

    <div className="skills-container-2">
        <div className="skills-html-5">
          <img className="html-5" alt="html-5" src="/images/html-5.svg" />
          <p>HTML5</p>
        </div>
        
        <div className="skills-css">
          <img className="css" alt="css" src="/images/css.svg" />
          <p>CSS3</p>
        </div>

        <div className="skills-javascript">
          <img className="javascript" alt="javascript" src="/images/javascript.svg" />
          <p>Javascript</p>
        </div>

        <div className="skills-react">
          <img className="react" alt="react" src="/images/react.svg" />
          <p>React</p>
        </div>
        
        <div className="skills-ruby">
          <img className="ruby" alt="ruby" src="/images/ruby.svg" />
          <p>Ruby</p>
        </div>
        
        <div className="skills-rails">
          <img className="rails" alt="rails" src="/images/rails.svg" />
          <p className="skills-p-rails">Rails</p>
        </div>

        <div className="skills-nodejs">
          <img className="nodejs" alt="nodejs" src="/images/nodejs.svg" />
          <p>NodeJS</p>
        </div>

        <div className="skills-r">
          <img className="r" alt="r" src="/images/r.svg" />
          <p>R</p>
        </div>
        
        <div className="skills-python">
          <img className="python" alt="python" src="/images/python.svg" />
          <p>Python</p>
        </div>

        <div className="skills-mongodb">
          <img className="mongodb" alt="mongodb" src="/images/mongodb.svg" />
          <p>MongoDB</p>
        </div>

        <div className="skills-express">
          <img className="express" alt="express" src="/images/express.svg" />
          <p>Express</p>
        </div>

        <div className="skills-postgresql">
          <img className="postgresql" alt="postgresql" src="/images/postgresql.svg" />
          <p>PostgreSQL</p>
        </div>

        <div className="skills-git">
          <img className="git" alt="git" src="/images/git.svg" />
          <p>Git</p> 
        </div>
       

        <div className="skills-github">
          <img className="github" alt="github" src="/images/github.svg" />
          <p>Github</p> 
        </div>
       

        <div className="skills-json">
          <img className="json" alt="json" src="/images/json.svg" />
          <p>JSON</p> 
        </div>
    
        <div className="skills-heroku">
          <img className="heroku" alt="heroku" src="/images/heroku.svg" /> 
          <p>Heroku</p>
       </div>

       <div className="skills-netlify">
          <img className="netlify" alt="netlify" src="/images/netlify.svg" /> 
          <p>Netlify</p>
       </div>

       <div className="skills-surge">
          <img className="surge" alt="surge" src="/images/surge.svg" /> 
          <p>Surge</p>
       </div>
          
        </div>
    </div >

    </div>
  )
}
